// src/components/card/CardFolderSensor.tsx

import { DeleteTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'

import {
  DeviceId,
  SensorId,
  SensorName,
  SensorProvider,
  SensorType,
  TypeInFolder,
} from '@/types/domain'

import {
  categoryByType,
  normalizedSensorType,
  SensorIcon,
  sensorType,
} from '../../api'
import {
  useDeviceId,
  useSensorName,
  useSensorProvider,
  useSensorType,
  useTypeInFolder,
} from '../../hooks'

type CardFolderSensorProps = {
  id: SensorId
  onDelete: () => void
  sensorTypes: any[]
}

export const CardFolderSensor = ({
  id,
  onDelete,
  sensorTypes,
}: CardFolderSensorProps) => {
  const navigate = useNavigate()

  const name: SensorName = useSensorName(id)
  const type: SensorType = useSensorType(id)
  const provider: SensorProvider = useSensorProvider(id)
  const deviceId: DeviceId = useDeviceId(id)
  const tif: TypeInFolder = useTypeInFolder(id)

  const src = SensorIcon(categoryByType(type, tif))

  return (
    <Card sx={{ border: 'solid 1px lightgray' }}>
      <CardHeader
        avatar={
          <Avatar>
            <Box component={'img'} src={src} />
          </Avatar>
        }
        subheader={`${provider} | ${deviceId}`}
        title={name}
      />

      <CardContent sx={{ p: 0 }}>
        <Divider />
        <List sx={{ p: 0 }}>
          {sensorTypes.map(type => {
            const {
              is_active,
              entity_id,
              sensor_type,
              status,
              sub_sensor_target: sst,
              type_in_folder: tif,
            } = type

            const icon = SensorIcon(
              normalizedSensorType(sensor_type, tif, sst),
              status
            )

            const onClick = () => navigate(`/sensors/${entity_id}`)

            const primary = `${sensorType(
              normalizedSensorType(sensor_type, tif, sst)
            )}`

            const secondary = `Sensor ID: ${entity_id} | ${
              ['deaktiviert', 'aktiviert'][is_active]
            }`

            return (
              <ListItem key={type.entity_id}>
                <ListItemAvatar>
                  <IconButton onClick={onClick}>
                    <Box alt={''} component={'img'} src={icon} width={30} />
                  </IconButton>
                </ListItemAvatar>

                <ListItemText primary={primary} secondary={secondary} />

                <IconButton edge={'end'} onClick={onDelete}>
                  <DeleteTwoTone />
                </IconButton>
              </ListItem>
            )
          })}
        </List>
      </CardContent>
    </Card>
  )
}
